import { upperCase, capitalizeWords } from '@/shared/lib/appHelpers'

export function findIntegrationCustomTemplateId(templateParam, userTemplates = []) {
  const param = String(templateParam ?? '').trim();
  if (!param) return null;
  const custom = userTemplates.find((tmpl) => String(tmpl.id) === param);
  return custom?.id ?? null;
}

export function resolveIntegrationTemplateId(templateParam, { templates = [], userTemplates = [] } = {}) {
  const customId = findIntegrationCustomTemplateId(templateParam, userTemplates);
  if (customId != null) return customId;

  const param = String(templateParam ?? '').trim();
  if (!param) return null;

  const paramLower = param.toLowerCase();
  const system = templates.find(
    (item) => String(item.value || '').replace(/_template/gi, '').toLowerCase() === paramLower
  );
  return system?.id ?? null;
}

export function buildTemplateOptions({ templates, userTemplates, t }) {
  const systemTemplates = [...templates].sort((a, b) => {
    if (a.name === "no template") return -1;
    if (b.name === "no template") return 1;
    return a.name.localeCompare(b.name);
  });
  const systemTemplatesWithId = systemTemplates.map((template) => ({
    ...template,
    id: template.id || template.value,
    value: template.id || template.value,
    _source: "system",
  }));

  const personalUser = (userTemplates || [])
    .filter((template) => template.owner_type !== "org")
    .sort((a, b) => String(a.name).localeCompare(String(b.name)))
    .map((template) => ({
      name: template.name,
      value: template.id,
      id: template.id,
      _source: "user",
      _owner: "personal",
    }));

  const orgUser = (userTemplates || [])
    .filter((template) => template.owner_type === "org")
    .sort((a, b) => String(a.name).localeCompare(String(b.name)))
    .map((template) => ({
      name: template.name,
      value: template.id,
      id: template.id,
      _source: "user",
      _owner: "org",
    }));

  return [...personalUser, ...orgUser, ...systemTemplatesWithId].map((template) => {
    if (template._source === "user") {
      const key =
        template._owner === "org"
          ? "form.templatePrefixOrganisation"
          : "form.templatePrefixPersonal";
      return { name: t(key, { name: template.name }), value: template.id };
    }
    const systemLabel = t(`reports.table.types.${upperCase(capitalizeWords(template.name))}`);
    return { name: systemLabel, value: template.id };
  });
}
